import { render, staticRenderFns } from "./Ico.vue?vue&type=template&id=1f98a734&"
import script from "./Ico.vue?vue&type=script&lang=js&"
export * from "./Ico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f98a734')) {
      api.createRecord('1f98a734', component.options)
    } else {
      api.reload('1f98a734', component.options)
    }
    module.hot.accept("./Ico.vue?vue&type=template&id=1f98a734&", function () {
      api.rerender('1f98a734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/Ico.vue"
export default component.exports